<template>
  <div style="position: relative">
    <div class="bg">
      <titleBar :titleName="pageName"></titleBar>
      <div class="X" v-if="openModal" @click="closeModal">X</div>
      <div class="content-block" v-if="!openModal">
        <div class="content"  style="padding-bottom: 24px">
          <div class="controller">
            <div class="no">1</div>
            <div class="sub-title">
              請問您的姓名
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <input type="text" v-model="name">
            </div>
            <p class="errorMsg" v-if="nameEmpty">請輸入姓名</p>
            <p class="errorMsg" v-if="nameType">請填寫「中文姓名」全名（最多五個字）</p>
          </div>
          <div class="controller">
            <div class="no">2</div>
            <div class="sub-title">
              請問您的手機號碼
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <input type="text" v-model="phone" inputmode="numeric">
            </div>
            <div class="errorMsg" v-if="phoneError">
              請確認手機格式
            </div>
          </div>
          <div class="controller">
            <div class="no">3</div>
            <div class="sub-title">
              請問您的性別
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <input type="radio" id="male" name="gender" value="男" v-model="gender">
              <label for="male">男</label>
              <input type="radio" id="female" name="gender" value="女" v-model="gender">
              <label for="female">女</label>
            </div>
          </div>
          <div class="controller">
            <div class="no">4</div>
            <div class="sub-title">
              請問您的婚姻狀況
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <select name="marriage" v-model="marriage" >
                <option :value="null" selected disabled>請選擇您的婚姻狀況</option>
                <option :value="i" v-for="(i , ind) in marriageOption" :key="ind+'asd'">{{ i }}</option>
              </select>
            </div>
          </div>
          <div class="controller">
            <div class="no">5</div>
            <div class="sub-title">
              請問您的生日<span style="font-size: 10px; padding-left: 4px">（選填）</span>
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <input type="date" v-model="birthday">
            </div>
          </div>
          <div class="controller">
            <div class="no">6</div>
            <div class="sub-title">
              展示中心
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <select v-if="!storeLoading && storeOption.length > 0" name="area" id="" v-model="store">
                <option :value="null" selected disabled>請選擇服務中心/展示中心</option>
                <option :value="i.sr_cd" v-for="(i, ind) in storeOption" :key="ind + 'dsa'">{{ i.dealername + ' ' + i.fullname }}</option>
              </select>
              <img v-if="storeLoading" src="../../assets/img/loading1.svg" alt="">
            </div>
          </div>
          <div class="controller">
            <div class="no">7</div>
            <div class="sub-title">
              銷售專員
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <select v-if="!salesLoading && store !== ''" name="sale" id="" v-model="sale">
                <option :value="null" selected disabled>請選擇服務專員</option>
                <option :value="i.id" v-for="(i, ind) in saleOption" :key="ind + 'dsa'">{{ i.name }}</option>
              </select>
              <img v-if="salesLoading" src="../../assets/img/loading1.svg" alt="">
            </div>
          </div>
          <div class="controller">
            <div class="no">8</div>
            <div class="sub-title">
              您有興趣的車款
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <div v-if="!carLoading" class="option-block">
                <div class="half" v-for="(car, index) in carOption" :key="index">
                  <input v-model="carModel" type="radio" :id="'option' + index" :value="car" name="carModel">
                  <label :for="'option' + index">{{ car }}</label>
                </div>
              </div>
              <img v-if="carLoading" src="../../assets/img/loading1.svg" alt="">
            </div>
          </div>
          <div class="controller">
            <div class="no">9</div>
            <div class="sub-title">
              請問您的休閒活動＆興趣<span style="font-size: 10px; padding-left: 4px">（選填，可複選）</span>
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <div class="option-block">
                <div :class="{'half': true, 'w-full': ind === 0 || ind >= 9}" v-for="(i, ind) in interestOption" :key="ind + '3'">
                  <input type="checkbox" :id="'2option' + ind" v-model="i.checked">
                  <label :for="'2option' + ind">{{ i.text }}</label>
                </div>
              </div>
            </div>
            <div class="errorMsg" v-if="interestError">
              休閒活動/興趣 最多選三個
            </div>
          </div>
          <div class="controller">
            <div class="no">10</div>
            <div class="sub-title">
              請問您是三菱車主嗎
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <input type="radio" id="yes" name="isCarOwner" value="1" v-model="ownerbrand">
              <label for="yes">是</label>
              <input type="radio" id="no" style="margin-left: 8px;" name="isCarOwner" value="0" v-model="ownerbrand">
              <label for="no">否</label>
            </div>
          </div>
          <div class="controller">
            <div class="no">11</div>
            <div class="sub-title">
              請問您此次前來的主要原因或來源為
            </div>
            <div class="form-controller">
              <div class="space"></div>
              <select v-if="!outreachLoading" v-model="outreachId" name="outreach" id="">
                <option :value="null" selected disabled>請選擇前來的主要原因或來源</option>
                <option v-for="option in outreachOption" :key="option.outreachId" :value="option.outreachId">{{ option.outreachName }}</option>
              </select>
              <img v-if="outreachLoading" src="../../assets/img/loading1.svg" alt="">
            </div>
          </div>
          <div class="controller">
            <div class="form-controller">
              <div class="space"></div>
              <input type="checkbox" id="agree" v-model="agree">
              <label for="agree" style="letter-spacing: 2px; z-index: 10">我同意上述 <span style="text-decoration: underline" @click="openPpModal">個資政策及其條款</span></label>
            </div>
          </div>
          <mainButton action-name="送出問卷" style="margin: 20px 0px; z-index: 10" @action="submitForm"></mainButton>
        </div>
      </div>
      <div class="content-block" v-if="openModal" style="min-height: 90vh !important;">
        <div  class="content" style="min-height: 45vh !important;">
          <p style="font-weight: bold;font-size: 16px;margin: 24px auto 16px auto; width: 90%;">依據個人資料保護法等相關規定，以下告知事項請 台端詳閱：</p>
          <p style="font-size: 14px;margin: 0px auto;width: 90%;">參加本活動前，請務必詳閱本活動辦法內容，當您透過本活動網站輸入個人資料參與活動時表示已同意下述蒐集個人資料告知事項與同意書之內容。</p>
          <p style="font-size: 14px;margin: 2px auto;width: 90%;">本人同意中華汽車工業股份有限公司(以下簡稱CMC)，依個人資料保護法規定，得為行銷及客戶服務管理之目的，於中華民國蒐集、處理及利用本人之上網登錄之個人資料，包含本人之姓名、聯絡電話等，並針對本人的需求提供個人化的行銷或服務內容。CMC將以包含但不限於簡訊、電話等聯絡方式，使本人知悉產品銷售、售後服務等權益事項、優惠、贈品或相關資訊及廣告。本人依照個人資料保護法得隨時請求CMC查閱、給予複本、或補正本人之個人資料，亦得隨時洽CMC之客服專線(0800--030-580) 拒絕CMC繼續蒐集、處理、利用或刪除本人之個人資料；本人同意由CMC依本同意書之約定持續蒐集、處理、利用本人所提供之個人資料，截至本人主動請求CMC刪除、停止處理或利用該個人資料之日或CMC執行業務所必需之保存期間止，CMC始終止其個人資料之蒐集、處理及利用。本人並同意CMC得將本人之個人資料提供予相對人之關係企業，於與前述目的類似之目的範圍內，蒐集、處理及利用。本人得自由選擇是否提供相關個人資料，惟若本人不提供時，本人瞭解將無法參加本活動。</p>
        </div>
      </div>

      <img src="../../assets/img/bg1.svg" alt="" class="bg-img-top-right">
      <img src="../../assets/img/bg2.svg" alt="" class="bg-img-bottom-left" @click="openConsole">
    </div>
    <loading :isLoading="isLoading"></loading>
  </div>
</template>

<script>
import loading from '../../components/loading'
import titleBar from "../../components/titleBar";
import mainButton from "../../components/mainButton";
import liff from "@line/liff";
import vConsoleMixin from '../../mixins/vConsoleMixin'

export default {
  components:{
    loading,
    titleBar,
    mainButton
  },
  mixins: [vConsoleMixin],
  data(){
    return {
      //system
      isLoading: false,
      isMaintenance: false,
      openModal :false,
      salesLoading: false,
      storeLoading: false,
      outreachLoading: false,
      carLoading: false,
      phoneError: false,
      interestError: false,
      nameEmpty: false,
      nameType: false,
      pageName: '從菱開始 好友召集令 問卷',
      //data
      dealer: this.$route.query.dealer,
      ministry: this.$route.query.ministry,
      name: '',
      phone: '',
      gender: '',
      marriage: '',
      birthday: '',
      store: '',
      sale: '',
      outreachId: '',
      ownerbrand: '',
      agree: false,
      carModel: '',
      marriageOption: ['單身', '已婚有小孩', '未婚有小孩', '已婚無小孩'],
      storeOption: [],
      saleOption: [],
      carOption: [],
      interestOption: [
        {
          text: '逛街、購物(實體店面)',
          value: '逛街、購物(實體店面)',
          checked: false,
        },
        {
          text: '線上網購',
          value: '線上網購',
          checked: false,
        },
        {
          text: '美食、烹飪',
          value: '美食、烹飪',
          checked: false,
        },
        {
          text: '政治、理財、投資',
          value: '政治、理財、投資',
          checked: false,
        },
        {
          text: '汽車、改裝相關',
          value: '汽車、改裝相關',
          checked: false,
        },
        {
          text: '3C、科技',
          value: '3C、科技',
          checked: false,
        },
        {
          text: '線上遊戲、動漫',
          value: '線上遊戲、動漫',
          checked: false,
        },
        {
          text: '寵物',
          value: '寵物',
          checked: false,
        },
        {
          text: '親子活動',
          value: '親子活動',
          checked: false,
        },
        {
          text: '攝影、戶外活動、旅遊',
          value: '攝影、戶外活動、旅遊',
          checked: false,
        },
        {
          text: '運動 / 觀看運動賽事',
          value: '運動 / 觀看運動賽事',
          checked: false,
        },
        {
          text: '視聽娛樂(追劇、演唱會、展覽等)',
          value: '視聽娛樂(追劇、演唱會、展覽等)',
          checked: false,
        },
        {
          text: '收藏:公仔、模型、手錶、鞋',
          value: '收藏:公仔、模型、手錶、鞋',
          checked: false,
        },
      ],
      outreachOption: [],
    }
  },
  created() {
    if (!this.dealer) {
      this.$swal({ text: '經銷商網址錯誤，請再確認活動連結是否正確' })
        .then(() => { liff.closeWindow() })
      return
    }
    if (!this.ministry) {
      this.$swal({ text: '部區網址錯誤，請再確認活動連結是否正確' })
        .then(() => { liff.closeWindow() })
      return
    }
  },
  async mounted() {
    if (!this.dealer || !this.ministry) return

    // 等待 500ms 讓手機的 WebView 網路連線建立完成 (特別是 iOS 從 4G 切換或剛開啟頁面時)，再開始打 API
    await new Promise(resolve => setTimeout(resolve, 500))

    // 改為依序執行（序列化）以避免瞬間並發過多 API 請求觸發 WAF 或資料庫滿載
    await this.fetchStoreList()
    await this.fetchOutreachList()
    await this.fetchCarList()

    await this.$recaptchaLoaded()
    const token = await this.$recaptcha('initCheck')
    window.localStorage.setItem('recaptcha', token)
    const url = process.env.VUE_APP_APIUrl + 'saveRecaptcha'
    const data = { recaptchaToken: token }
    await this.axios.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
      }
    })
  },
  watch:{
    name: {
      handler: function () {
        this.checkName()
      },
    },
    interest: {
      handler: function(newValue) {
        this.interestError = newValue.length > 3
      }
    },
    store: {
      handler: function(newValue) {
        if(newValue !== ''){
          this.fetchSaleList()
        }
      }
    },
    phone: {
      handler: function() {
        this.checkPhone()
      },
    },
  },
  computed: {
    interest() {
      return this.interestOption.filter(i => i.checked)
    }
  },
  methods:{
    // 檢查是否為網路底層錯誤 (Status 0 / Network Error)
    isNetworkError(e) {
      return !e.response || e.response.status === 0 || e.message === 'Network Error' || e.code === 'ERR_NETWORK';
    },
    submitForm(){
      if (!this.agree) {
        this.$swal({ text: '請同意條款' })
        return
      }
      this.checkName()
      this.checkPhone()
      if ([this.marriage, this.gender, this.carModel, this.ownerbrand, this.store, this.sale, this.outreachId].includes('')
        || [this.phoneError, this.nameEmpty, this.nameType, this.interestError].includes(true)) {
        this.$swal({ text: '請檢查欄位都已填寫，並格式正確' })
        return
      }

      this.saveAnswer({
        reason: '賞車',
        name: this.name,
        mobile: this.phone,
        married: this.marriage,
        gender: this.gender,
        birthday: this.birthday,
        cartype: this.carModel,
        interest: this.interest.map(item => item.value).join('&'),
        ownerbrand: this.ownerbrand,
        dealer: this.dealer,
        sr_cd: this.store,
        salesman: this.sale,
        ministry: this.ministry,
        outreach_id: this.outreachId,
        outreach_name: this.outreachOption.find(item => item.outreachId === this.outreachId)?.outreachName || '',
        recaptchaToken: window.localStorage.getItem('recaptcha')
      })
    },
    checkName() {
      this.nameEmpty = this.name === ''
      this.nameType = !this.nameEmpty && !/^[\u4e00-\u9fa5]{1,5}$/.test(this.name)
    },
    checkPhone() {
      this.phoneError = !/^09\d{8}$/.test(this.phone)
    },
    async saveAnswer(data) {
      this.isLoading = true
      const url = process.env.VUE_APP_APIUrl + 'saveInVisitorAnswer'
      await this.axios.post(url, data, {
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then(() => {
        this.$swal({
          html: '資料提交成功！<br/>感謝您填寫資料，祝您賞車愉快！',
          type: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "確定"
        }).then(() => {
          liff.closeWindow()
        })
      }).catch((e) => {
        if(e.response.data.msg === 'invalid paramaters'){
          this.$swal({
            text: '請檢查輸入欄位格式正確，不可為空白',
          })
        } else {
          this.$swal({
            text: e.response.data.msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "確定"
          }).then(() => {
            liff.closeWindow()
          })
        }
      }).finally(() =>{
        this.isLoading = false
      })
    },
    async fetchStoreList(retryCount = 0) {
      this.storeLoading = true
      const url = process.env.VUE_APP_APIUrl + 'getSalesNodeList'
      const data = { dealer: this.dealer, ministry: this.ministry }
      try {
        const res = await this.axios.post(url, data, {
          headers: { Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken') }
        })
        if (res.data.msg !== 'success') throw new Error(res.data.msg)
        const rawStoreData = res.data.data
        
        // 確保為陣列，並過濾掉無效資料（例如 null 或空物件），避免導致 Vue 渲染時崩潰
        let storeData = []
        if (Array.isArray(rawStoreData)) {
          storeData = rawStoreData.filter(item => item && item.sr_cd)
        }

        // 如果過濾後長度為 0 (包含原本是空物件、null等)，就視為異常並重試
        if (storeData.length === 0) {
          // return await 確保 finally 等遞迴完成後才執行，不會有 storeLoading 提前 false 的問題
          if (retryCount < 1) return await this.fetchStoreList(retryCount + 1)
          throw new Error('展示中心資料格式異常，請重新開啟活動連結')
        }

        this.storeOption = storeData
      } catch (e) {
        // 檢查是否為網路連線層的異常
        const isNetworkError = this.isNetworkError(e);
        if (isNetworkError && retryCount < 2) {
          console.warn('fetchStoreList Status 0 / Network Error, retrying...', retryCount)
          await new Promise(resolve => setTimeout(resolve, 1000))
          return await this.fetchStoreList(retryCount + 1)
        }
        // 取得 axios 的 API 錯誤訊息，或是上面 throw 丟出來的 error message
        const errorMsg = e?.response?.data?.msg || e.message || '連線異常，請重試'
        // 用 toast 取代 swal，不會覆蓋其他正在顯示的 swal
        // onClose callback 確保 toast 關閉後才執行 closeWindow
        this.$toast.error(errorMsg, { timeout: false, onClose: () => liff.closeWindow() })
      } finally {
        this.storeLoading = false
      }
    },
    async fetchSaleList(){
      this.salesLoading = true
      const url = process.env.VUE_APP_APIUrl + 'getSalesmanList'
      const data = {
        "dealer": this.dealer,
        "sr_cd": this.store
      }
      await this.axios.post(url, data, {
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then((res) => {
        if(res.data.msg === 'success'){
          this.saleOption = res.data.data
        }
      }).catch((e) => {
        const errorMsg = e?.response?.data?.msg || e.message || '連線異常，請重試'
        this.$toast.error(errorMsg)
      }).finally(() => {
        this.salesLoading = false
      })
    },
    async fetchOutreachList(retryCount = 0){
      this.outreachLoading = true
      const url = process.env.VUE_APP_APIUrl + 'getOutreachList'
      await this.axios.get(url, {
        params: {
          dealer: this.dealer,
        },
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then((res) => {
        this.outreachOption = res.data.data
      }).catch(async (e) => {
        const isNetworkError = this.isNetworkError(e);
        if (isNetworkError && retryCount < 2) {
          console.warn('fetchOutreachList Status 0 / Network Error, retrying...', retryCount)
          await new Promise(resolve => setTimeout(resolve, 1000))
          return await this.fetchOutreachList(retryCount + 1)
        }
        const errorMsg = e?.response?.data?.msg || e.message || '連線異常，請重試'
        this.$toast.error(errorMsg)
      }).finally(() => {
        this.outreachLoading = false
      })
    },
    async fetchCarList(retryCount = 0){
      this.carLoading = true
      const url = process.env.VUE_APP_APIUrl + 'getInVistorCarList'
      await this.axios.get(url, {
        params: {
          dealer: this.dealer,
        },
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then((res) => {
        const carData = res.data.data || []
        this.carOption = carData.map(item => item.marketName)
      }).catch(async (e) => {
        const isNetworkError = this.isNetworkError(e);
        if (isNetworkError && retryCount < 2) {
          console.warn('fetchCarList Status 0 / Network Error, retrying...', retryCount)
          await new Promise(resolve => setTimeout(resolve, 1000))
          return await this.fetchCarList(retryCount + 1)
        }
        const errorMsg = e?.response?.data?.msg || e.message || '連線異常，請重試'
        this.$toast.error(errorMsg)
      }).finally(() => {
        this.carLoading = false
      })
    },
    closeModal(){
      this.openModal= false
      this.pageName = '從菱開始 好友召集令 問卷'
    },
    openPpModal(){
      this.openModal= true
      this.pageName = '個資同意'
    }
  }
}
</script>

<style lang="scss" scoped>

input{
  color:black !important;
}

.w-full{
  width: 100% !important;
}
.content-block{
  width: 95%;
  margin: 16px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px -4px 0px #D9363E;
  min-height: 100vh;
}

.bg{
  background: #EFEFEE;
  position: relative;
  height: 100%;
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  .bg-img-top-right{
    position: absolute;
    top: 0;
    right: 0;
  }
  .bg-img-bottom-left{
    position: absolute;
    bottom: 0;
    left: 0;
  }

}

.content{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .controller{
    display: inline-flex;
    flex-wrap: wrap;
    width: 95%;
    margin: 12px auto;
    .no{
      width: 15%;
      font-size: 20px;
      font-weight: bold;
      color: gray;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .sub-title{
      width: 85%;
      font-size: 18px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
    .form-controller{
      width: 100%;
      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
      z-index: 10;
      .space{
        width: 15%;
        height: 5px;
      }
      .option-block{
        width: 85%;
        display: inline-flex;
        flex-wrap: wrap;
        margin-top: 8px;
        .half{
          width: 50%;
          height: 50px;
          input[type = 'checkbox']{
            width: 16px;
            height: 16px;
          }
          label{
            font-size: 15px;
            margin: 4px 6px;
            font-weight: bold;
          }
        }
      }
      input[type = 'checkbox']{
        width: 16px;
        height: 16px;
      }
      input[type = 'radio']{
        width: 16px;
        height: 16px;
      }
      input[type = 'text']{
        width: 85%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #c1c1c1;
        margin-top: 6px;
        text-align: center;
        background: #fff;
      }
      input[type = 'date']{
        width: 85%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #c1c1c1;
        margin-top: 6px;
        text-align: center;
        background: #fff;
      }
      select{
        width: 85%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #c1c1c1;
        text-align: center;
        margin-top: 8px;
        background: #fff;
      }
      input:focus, select:focus{
        outline: none;
      }
      label{
        font-size: 15px;
        margin: 4px 6px;
        font-weight: bold;
      }
    }
  }
}

input{
  color: black !important;
  text-align: center !important;
}

.X{
  position: absolute;
  top: 6px;
  left: 22px;
  font-size: 32px;
  color: white;
  z-index: 10;
}

.errorMsg{
  width: 100%;
  margin-top: 8px;
  color: #C40017;
  font-size: 16px;
  text-align: right;
}
</style>
